import { Component, OnInit, Input } from '@angular/core';

import { Customer } from '../../../../shared/models/customer';
import { DeliveryFeeTable } from '../../../../shared/models/delivery-fee-table';

import { CustomerService } from '../../../../shared/services/customer.service';
import { DeliveryService } from '../../../../shared/services/delivery.service';

import { Router, ActivatedRoute } from '@angular/router';

import { faSpinner } from '../../../../icons';  // adjust path

@Component({
    selector: 'app-customer-details',
    templateUrl: './customer-details.component.html',
    styleUrls: ['./customer-details.component.scss'],
    standalone: false
})
export class CustomerDetailsComponent implements OnInit {
	@Input() customer: Customer;

  errorMsgs: {[field: string]: string} = {};
  deliveryFeeTable: DeliveryFeeTable;
  selectedDistrict: {bairro: string, valor: string};

  mode: 'delivery'|'pickup' = 'delivery';

  sending: boolean;

  addressPlaceholder = `Insira aqui informações do seu endereço`;

  faSpinner = faSpinner;

  constructor(private customerServ: CustomerService,
    private deliveryServ: DeliveryService,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.customer = this.customerServ.getCustomer() || this._newCustomer();

    this.deliveryServ.getCurrent().subscribe(
      res => {
        if(res == null) {
          this.customer.address = null;
          this.customer.district = null;
          this.mode = 'pickup';
          return;
        }
        this.deliveryFeeTable = res;
        this.selectedDistrict = this.deliveryServ.getSelectedDistrictObj();
      },
      err => {
        console.error(err);
      }
    );
    this.selectedDistrict = this.deliveryServ.getSelectedDistrictObj();
    if(this.selectedDistrict)
      this.customer.district = this.selectedDistrict.bairro;
    else
      this.customer.district = '';
  }

  back() {
  	this.router.navigate(['../carrinho'], {relativeTo: this.route});
  }

  done() {
    this.checkNameFormat(this.customer, 'name');
    this.checkNameFormat(this.customer, 'surname');

    this.sending = true;
    if(!this._validInfo()) {
      this.sending = false;
      setTimeout(() => {
        document.getElementsByClassName("error-label")[0].scrollIntoView({behavior: 'smooth'});
      }, 100);
      return;
    }

    this.customer.coords = null;

    this.customerServ.getToken(this.customer.name, this.customer.surname, this.customer.phone).subscribe(
      res => {
        this.customer.name = this.customer.name + ' ' + this.customer.surname;
        this.customer.surname = '';
        
        if(res) {
          this.customer.token = res.token;
          this.customerServ.updateCustomer(this.customer.token, this.customer).subscribe(
            res => {
              this.deliveryServ.selectDistrictObj(this.selectedDistrict);
              setTimeout(() => {
                this.customer = this.customerServ.getCustomer();
                this.router.navigate(['../checkout'], {relativeTo: this.route});
              }, 300);
            },
            err => {
              this.sending = false;
            }
          );
        } else {
          this.customerServ.createCustomer(this.customer, true, this.selectedDistrict).subscribe(
            res => {
              setTimeout(() => {
                this.router.navigate(['../checkout'], {relativeTo: this.route});
              }, 100)
            },
            err => {
              this.sending = false;
            },
            () => {}
          );
        }
      },
      err => {
        this.customer.name = this.customer.name + ' ' + this.customer.surname;
        this.customer.surname = '';
        if(err == null) { // user is new
          this.customerServ.createCustomer(this.customer, true, this.selectedDistrict).subscribe(
            res => {
              setTimeout(() => {
                this.router.navigate(['../checkout'], {relativeTo: this.route});
              }, 300);
            },
            err => {
              this.sending = false;
            },
            () => {}
          );
        }
      },
      () => {
        setTimeout(() => {
          this.sending = false;
        }, 100);
      }
    )
  }

  onDistrictChange(districtObj: {bairro: string, valor: string}) {
    if(districtObj == null) {
      this.selectedDistrict = {bairro: '', valor: '0'};
    } else {
      this.selectedDistrict = districtObj;
    }
  }

  checkNameFormat(obj, field) {
    // Match characters, accented or not
    let regex = /\p{Letter}+$/u;

    setTimeout(() => {
      for(let i = 0; i < obj[field].length; i++) {
        let ch = obj[field].charAt(i);
        if(regex.test(ch)) {
          // valid input
        } else {
          let letters = obj[field].split('');
          letters.splice(i, 1);
          obj[field] = letters.join('');
          i--;
        }
      }
    }, 50);
  }

  // TODO
  private _validInfo(): boolean {
    this.errorMsgs = {};

    // do some validation
    if(this.customer.phone.length < 11) {
      this.errorMsgs.phone = "Telefone inválido";
    }
    if(this.customer.name.length < 3) {
      this.errorMsgs.name = "Nome inválido. Apenas letras são permitidas (mínimo de 3 letras)";
    }
    if(this.customer.surname.length < 3) {
      this.errorMsgs.surname = "Sobrenome inválido. Apenas letras são permitidas (mínimo de 3 letras)";
    }
    if(this.mode == 'delivery') {
      if(this.customer.address.length < 8) {
        this.errorMsgs.address = "Endereço inválido. Apenas letras são permitidas (mínimo de 8 letras)";
      }
      if(!this.customer.district || this.customer.district == '') {
        this.errorMsgs.district = "Bairro não pode ficar em branco";
      }
    } else {
      this.customer.address = null;
      this.customer.district = null;
    }

    return JSON.stringify(this.errorMsgs) == "{}";
  }

  private _newCustomer(): Customer {
  	return <Customer>{
  		name: '',
      surname: '',
  		phone: '',
      email: '',
  		address: '',
  		district: ''
  	};
  }
}
